import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, MessageCircleOff, BookX, Timer, CheckCircle2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { DjayAvatar } from '../../mascot/DjayAvatar';
import { DOMAIN_META } from '../utils/assessmentDomainConfig';
import type { AssessmentDomainId } from '../types';
interface AssessmentIntroScreenProps {
  domainId: AssessmentDomainId;
  questionCount: number;
  onStart: () => void;
  onCancel: () => void;
}
export function AssessmentIntroScreen({
  domainId,
  questionCount,
  onStart,
  onCancel
}: AssessmentIntroScreenProps) {
  const meta = DOMAIN_META[domainId];
  const minutesPerQuestion = domainId === 'rekenen' ? 1.4 : 1.2;
  const estimatedMinutes = Math.round(questionCount * minutesPerQuestion);
  return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-slate-800" data-id="element-853">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md text-center" data-id="element-854">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 0.15,
        type: 'spring',
        bounce: 0.4
      }} className="flex justify-center mb-6" data-id="element-855">
          <DjayAvatar size="hero" emotion="encouraging" animate data-id="element-856" />
        </motion.div>

        <h1 className="text-3xl font-black text-slate-900 mb-2 tracking-tight" data-id="element-857">
          {meta.label}
        </h1>
        <p className="text-slate-500 text-sm font-medium mb-8" data-id="element-858">Toets</p>

        <div className="flex items-center justify-center gap-6 text-slate-600 font-medium mb-10" data-id="element-859">
          <div className="flex items-center" data-id="element-860">
            <CheckCircle2 className="w-4 h-4 mr-2 text-slate-400" data-id="element-861" />
            {questionCount} vragen
          </div>
          <div className="flex items-center" data-id="element-862">
            <Clock className="w-4 h-4 mr-2 text-slate-400" data-id="element-863" />~{estimatedMinutes}{' '}
            minuten
          </div>
        </div>

        <div className="space-y-4 mb-10 text-left inline-block" data-id="element-864">
          <div className="flex items-center gap-4" data-id="element-865">
            <MessageCircleOff className="w-5 h-5 text-slate-400 shrink-0" data-id="element-866" />
            <p className="text-slate-600 font-medium" data-id="element-867">
              Geen feedback na elke vraag
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-868">
            <BookX className="w-5 h-5 text-slate-400 shrink-0" data-id="element-869" />
            <p className="text-slate-600 font-medium" data-id="element-870">
              Geen spiekbriefje of hulp
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-871">
            <Timer className="w-5 h-5 text-slate-400 shrink-0" data-id="element-872" />
            <p className="text-slate-600 font-medium" data-id="element-873">Neem rustig de tijd</p>
          </div>
        </div>

        <Button onClick={onStart} size="xl" fullWidth className="bg-orange-500 text-white hover:bg-orange-600 shadow-xl rounded-2xl text-fluid-lg font-bold mb-6" data-id="element-874">
          <span className="mr-2" data-id="element-875">Ik ben er klaar voor</span>
          <ArrowRight className="w-5 h-5" strokeWidth={3} data-id="element-876" />
        </Button>

        <button onClick={onCancel} className="text-sm text-slate-400 hover:text-slate-600 font-medium transition-colors" data-id="element-877">
          Annuleren en terug
        </button>
      </motion.div>
    </div>;
}